'use strict'

module.exports = {
  SITE_URL: '"https://www.bladmjudicial.com.br"',
  // SITE_URL: '"https://api-bladmjudicial.owinteractive.com/v1"',

  //API_URL: '"http://api.bladmjudicial.com.self/v1"'
  API_URL: '"https://api.bladmjudicial.com.br/v1"',
};



//////////////////
// WEBPACK FOOTER
// ./config/local.env.js
// module id = 123
// module chunks = 1